
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#5C6970","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.906h13.938v4.532H19.5v18.156H.75V.906z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h12.025A6.483 6.483 0 0120 6.473V12.5a.5.5 0 01-1 0V6.473c0-.153-.007-.312-.022-.473H15.5c-.827 0-1.5-.673-1.5-1.5V1.022A5.127 5.127 0 0013.525 1H1.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h3a.5.5 0 010 1h-3zM15 4.5a.5.5 0 00.5.5h3.297A5.493 5.493 0 0015 1.203V4.5z"}}),_c('path',{attrs:{"d":"M7.5 24a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5c2.481 0 4.5 2.019 4.5 4.5S9.981 24 7.5 24zm.5-1.036a3.51 3.51 0 003-3.464 3.51 3.51 0 00-3-3.464v6.928zM15.5 24a2.503 2.503 0 01-2.5-2.5v-4c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v4c0 1.378-1.122 2.5-2.5 2.5zm0-8c-.827 0-1.5.673-1.5 1.5v4c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-4c0-.827-.673-1.5-1.5-1.5zm8 8a4.505 4.505 0 01-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5a.5.5 0 010 1c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5a.5.5 0 010 1z"}})])
          )
        }
      }
    